import React, { useState } from 'react';
import { normalizeTags } from '../mediaHelpers';

/**
 * Tag editor: existing tags as removable chips plus a text input.
 *   <TagInput value={tags} onChange={setTags} id="media-tags" />
 * Enter or comma commits the typed tag; Backspace in an empty input removes the
 * last one. Values are always trimmed and de-duplicated (normalizeTags).
 */
export default function TagInput({ value = [], onChange, id, placeholder = 'Add a tag…', disabled = false }) {
  const [draft, setDraft] = useState('');

  const commit = (raw) => {
    const next = normalizeTags([...(value || []), raw]);
    setDraft('');
    if (next.length !== (value || []).length) onChange(next);
  };

  const remove = (tag) => onChange((value || []).filter((t) => t !== tag));

  const onKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ',') {
      e.preventDefault();
      if (draft.trim()) commit(draft);
    } else if (e.key === 'Backspace' && !draft && (value || []).length) {
      e.preventDefault();
      remove(value[value.length - 1]);
    }
  };

  return (
    <div>
      {(value || []).length > 0 && (
        <div className="chip-group" style={{ marginBottom: '8px' }}>
          {value.map((tag) => (
            <button
              key={tag}
              type="button"
              className="chip"
              onClick={() => remove(tag)}
              disabled={disabled}
              aria-label={`Remove tag ${tag}`}
              title={`Remove ${tag}`}
            >
              {tag}
              <span aria-hidden="true">×</span>
            </button>
          ))}
        </div>
      )}
      <input
        id={id}
        type="text"
        className="input"
        value={draft}
        disabled={disabled}
        placeholder={placeholder}
        onChange={(e) => setDraft(e.target.value)}
        onKeyDown={onKeyDown}
        onBlur={() => draft.trim() && commit(draft)}
      />
      <div className="hint muted small">Press Enter or comma to add. Click a tag to remove it.</div>
    </div>
  );
}
